module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "LianchuangWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LianchuangWalletView!./src/pages/Shop/Member/Wallet/LianchuangWallet/indexView.js
// module id = 1046
// module chunks = 438